import React from 'react';

interface FilterPillProps {
  filters: string[];
  onDeleteFilter: (filter: string) => void;
}

// Todo: Add in ability for user to click and delete on individual filters.
export const FilterPill = ({ filters, onDeleteFilter }: FilterPillProps) => {
  // Don't render anything if there are no filters
  if (filters.length === 0) {
    return null;
  }

  return (
    <div className="filter_bar_container">
      <span className="filter_bar_label">Active filters:</span>
      <div className="filter_bar">
        {filters.map((filter) => (
          <div key={filter} className="filter_bar__filter">
            {filter}
          </div>
        ))}
      </div>
    </div>
  );
};
